var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxBusinessBriefVersion1Outline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0931 6.12305H3.90847C3.29671 6.12305 2.80078 6.61898 2.80078 7.23074V16.0923C2.80078 16.7041 3.29671 17.2 3.90847 17.2H16.0931C16.7049 17.2 17.2008 16.7041 17.2008 16.0923V7.23074C17.2008 6.61898 16.7049 6.12305 16.0931 6.12305Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78543 2.80078H12.2162C12.51 2.80078 12.7917 2.91748 12.9995 3.12522C13.2072 3.33295 13.3239 3.61469 13.3239 3.90847V6.12386H6.67773V3.90847C6.67773 3.61469 6.79444 3.33295 7.00217 3.12522C7.2099 2.91748 7.49164 2.80078 7.78543 2.80078Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxBusinessBriefVersion1Outline);
export default __webpack_public_path__ + "static/media/icon_20px_business-brief_version1_outline.793dfaafb5b57c5488c45c48b8221bd2.svg";
export { ForwardRef as ReactComponent };